"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
exports.reducer = function (state, action) {
    if (state === void 0) { state = {}; }
    switch (action.type) {
        case 'UPDATE_STATE':
            return tslib_1.__assign(tslib_1.__assign({}, state), action.value);
        case 'RESET_STATE':
            return {};
        default:
            return state;
    }
};
//# sourceMappingURL=reducer.js.map